import { styled, Typography } from '@material-ui/core';
import { Link } from 'react-router';

import { down } from '../../../assets/style/breakpointHelpers';
import { domTag } from '../../utils/styledFilter';

export const HeaderContainer = styled('div')({
	display: 'flex',
	padding: '5px 15px 15px',
	alignItems: 'center',
	zIndex: 1030,
	position: 'fixed',
	background: 'var(--color-bg-primary)',
	width: '100%',
	top: 0,
	left: 0,
	borderBottom: '1px solid var(--color-border-subtle)',
	transition: 'background-color var(--transition-normal), border-color var(--transition-normal)',
});

export const NavLinks = styled('div')({
	display: 'flex',
	alignItems: 'center',
});

export const HamburgerButton = styled('button')({
	'display': 'flex',
	'alignItems': 'center',
	'justifyContent': 'center',
	'width': 40,
	'height': 40,
	'padding': 8,
	'marginLeft': 4,
	'border': 'none',
	'borderRadius': 'var(--radius-lg)',
	'backgroundColor': 'transparent',
	'color': 'var(--color-text-primary)',
	'cursor': 'pointer',
	'transition': 'background-color var(--transition-fast)',
	'&:hover': {
		backgroundColor: 'var(--color-bg-hover)',
	},
	'&:focus-visible': {
		outline: '2px solid var(--color-border-focus)',
		outlineOffset: 2,
	},
});

export const MobileMenu = styled(domTag('nav', ['isOpen']))(({ isOpen }: { isOpen: boolean }) => ({
	position: 'fixed',
	top: 60,
	left: 0,
	right: 0,
	backgroundColor: 'var(--color-bg-elevated)',
	borderBottom: '1px solid var(--color-border-default)',
	boxShadow: 'var(--shadow-lg)',
	padding: isOpen ? '16px' : 0,
	maxHeight: isOpen ? '300px' : 0,
	overflow: 'hidden',
	opacity: isOpen ? 1 : 0,
	transform: isOpen ? 'translateY(0)' : 'translateY(-8px)',
	transition:
		'max-height var(--transition-normal), padding var(--transition-normal), opacity var(--transition-fast), transform var(--transition-fast)',
	zIndex: 1020,
	display: 'flex',
	flexDirection: 'column',
	gap: 8,
	[down('md')]: {},
}));

export const MobileMenuLink = styled(Link)({
	'display': 'block',
	'padding': '12px 16px',
	'fontFamily': 'var(--font-family-regular)',
	'fontSize': 'var(--text-body-size)',
	'lineHeight': 'var(--leading-normal)',
	'color': 'var(--color-text-primary)',
	'textDecoration': 'none',
	'borderRadius': 'var(--radius-md)',
	'transition': 'background-color var(--transition-fast), color var(--transition-fast)',
	'&:hover': {
		backgroundColor: 'var(--color-bg-hover)',
		color: 'var(--color-text-primary)',
		textDecoration: 'none',
	},
	'&:focus-visible': {
		outline: '2px solid var(--color-border-focus)',
		outlineOffset: -2,
	},
});

export const Logo = styled('img')({
	marginRight: 20,
});

export const Hamburger = styled('img')({
	marginRight: 10,
	cursor: 'pointer',
});

export const ProfileContainer = styled('div')({
	padding: 0,
	display: 'flex',
	alignItems: 'center',
	marginLeft: 'auto',
});

export const ProfileSection = styled('div')({
	display: 'flex',
	flexDirection: 'column',
});

export const ProfileName = styled(Typography)({
	fontFamily: 'var(--font-family-medium)',
	fontSize: 'var(--text-body-size)',
	lineHeight: 'var(--leading-normal)',
	margin: 0,
	color: 'var(--color-text-primary)',
});

export const ProfileRole = styled(Typography)({
	fontFamily: 'var(--font-family-medium)',
	fontSize: 'var(--text-body-sm-size)',
	lineHeight: 'var(--leading-normal)',
	margin: 0,
	color: 'var(--color-text-inverse)',
	height: 24,
	width: 'max-content',
	padding: '0 12px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	border: '1px solid',
	borderRadius: 35,
});

export const ProfileImage = styled('img')({
	borderRadius: '50%',
	width: 22,
	height: 22,
});

export const ProfileNotification = styled('img')({
	width: 20,
	height: 20,
	marginRight: 35,
	cursor: 'pointer',
	[down('sm')]: {
		display: 'none',
	},
});

export const ProfileEllippisContainer = styled('div')({
	width: 30,
	height: 40,
	cursor: 'pointer',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'flex-end',
});

export const ProfileEllippis = styled('img')({
	width: 15,
	height: 15,
});

export const DropdownItem = styled('li')({
	fontFamily: 'var(--font-family-regular)',
	fontSize: 'var(--text-body-sm-size)',
	lineHeight: 'var(--leading-normal)',
	cursor: 'pointer',
});

export const LinkContainer = styled(Link)({
	'fontFamily': 'inherit',
	'fontSize': 'inherit',
	'color': 'var(--color-text-primary)',
	'display': 'flex',
	'textDecoration': 'none',
	'borderRadius': 'var(--radius-md)',
	'padding': '4px 8px',
	'transition': 'background-color var(--transition-fast), color var(--transition-fast)',
	'&:hover': {
		textDecoration: 'none',
		color: 'var(--color-text-primary)',
		backgroundColor: 'var(--color-bg-hover)',
	},
	'&:focus-visible': {
		outline: '2px solid var(--color-border-focus)',
		outlineOffset: 2,
	},
});
